import(/* webpackMode: "eager", webpackExports: ["CookiebotScript"] */ "/app/src/components/Analytics/CookiebotScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PromoPopup"] */ "/app/src/components/PromoPopup/PromoPopup.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/css/main.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/(entrix)/[lang]/layout.module.css");
